import type { ProductModelDetail } from '@shared/shop-api/product/details/types'
import type {
  ProductModelDetailFragment,
  ProductModelDetailLabelFragment,
  ProductModelDetailsFragment,
} from '@shared/types/storefront/graphql'

export const isProductModelDetailFragment = (
  node: unknown
): node is ProductModelDetailFragment => {
  const isObject = typeof node === 'object' && node !== null
  const hasValue = isObject && 'value' in node
  const hasLabel = isObject && 'label' in node

  return hasValue && hasLabel
}

export const isProductModelDetailLabelFragment = (
  reference: unknown
): reference is ProductModelDetailLabelFragment => {
  const isObject = typeof reference === 'object' && reference !== null
  const hasLabel = isObject && 'label' in reference

  return hasLabel
}

export const toProductModelDetails = (
  details: ProductModelDetailsFragment | undefined | null
) => {
  if (!details?.references?.nodes) {
    return []
  }

  return details.references.nodes
    .map((node) => {
      if (!isProductModelDetailFragment(node)) {
        return null
      }

      return toProductModelDetail(node)
    })
    .filter(Boolean) as ProductModelDetail[]
}

export const toProductModelDetail = (detail: ProductModelDetailFragment) => {
  if (
    !detail.value?.value ||
    !isProductModelDetailLabelFragment(detail.label?.reference) ||
    !detail.label.reference.label?.value
  ) {
    return null
  }

  return {
    value: detail.value.value,
    label: detail.label.reference.label.value,
  }
}
